import React from "react";
import "../../../Style/Services/SecendSection.css";

function WeHelpYou() {
  return (
    <div className="SecendSection">
      <h1>
        From Designing to On-Site <br /> support, we help you{" "}
      </h1>{" "}
      <br /> <br />
      <span className="sub-title">
        'We have in house facility for{" "}
        <span className="blue-sub-title">CPRI Approved</span> Electrical Panels
        with Technical Expects, in Design, drawing & Manufacturing.'
      </span>
    </div>
  );
}

export default WeHelpYou;
